import React, {Component} from "react";
import {logoFacebookChatBox} from '../../config';
import axios from 'axios';
import {Modal, FormLayout, TextField, Banner} from '@shopify/polaris';
import SubmitIssue from '../SubmitIssue';

class InitTopMenuBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      shopData: null,
      instructionVideoModal: false,
      submitIssueModal: false,
      thanksIssueModal: false,
      issueSubjectValue: '',
      issueSubjectError: '',
      issueDetailValue: '',
      issueDetailError: '',
    }
  }

  getShopData(shopUrl) {
    const url = `https://website-service-dot-autoketing-production-api-v1.appspot.com/get-data-shop`;
    const e = this;
    axios.get(url, {params: {shop_domain: shopUrl}})
      .then(function (response) {
        if (response.status === 200) {
          e.setState({shopData: response.data});
        } else {
          // console.error('response error');
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  runToShowInstructionVideo = () => {
    this.setState({instructionVideoModal: true});
  };

  closeInstructionVideo = () => {
    this.setState({instructionVideoModal: false});
  };

  showSubmitIssueModal = () => {
    this.setState({submitIssueModal: true});
  };

  closeSubmitIssueModal = () => {
    this.setState({submitIssueModal: false});
  };

  componentDidMount() {
    function getVal(str) {
      const v = window.location.search.match(
        new RegExp('(?:[?&]' + str + '=)([^&]+)')
      );
      return v ? v[1] : undefined;
    }

    const notRedirect = getVal('not-redirect');
    const shopUrl = getVal('shop');
    this.getShopData(shopUrl);

    const e = this;
    if (!notRedirect) {
      window.ShopifyApp.Bar.loadingOff();

      const appName = this.props.appName;
      switch (appName) {
        case 'fb-chat':
          window.ShopifyApp.Bar.initialize({
            buttons: {
              secondary: [
                {
                  label: 'FAQ',
                  type: 'dropdown',
                  links: [
                    {
                      label: 'Instruction video',
                      callback: function () {
                        e.runToShowInstructionVideo();
                      }
                    },
                    {
                      label: 'Read document',
                      href:
                        'https://autoketing.freshdesk.com/support/solutions/articles/42000030328-how-to-set-up-facebook-chat-box',
                      target: 'new'
                    },
                    {
                      label: 'Submit issue',
                      callback: function () {
                        e.showSubmitIssueModal();
                      }
                    }
                  ]
                },
                {
                  label: 'Leave a Review',
                  href:
                    'https://apps.shopify.com/facebook-chat-box?reveal_new_review=true',
                  target: 'new'
                }
              ]
            },
            icon: logoFacebookChatBox
          });
          break;
        case 'sales-pop':
          window.ShopifyApp.Bar.initialize({
            buttons: {
              secondary: [
                {
                  label: 'FAQ',
                  type: 'dropdown',
                  links: [
                    {
                      label: 'Read document',
                      href:
                        'https://autoketing.freshdesk.com/support/solutions/42000063637',
                      target: 'new'
                    },
                    {
                      label: 'Submit issue',
                      callback: function () {
                        e.showSubmitIssueModal();
                      }
                    }
                  ]
                },
                {
                  label: 'Leave a Review',
                  href: 'https://apps.shopify.com/sales-pop-master?reveal_new_review=true',
                  target: 'new'
                }
              ]
            },
            icon: logoFacebookChatBox
          });
          break;
        default:
          break;
      }
    }
  }

  submitIssueAction = () => {
    const {issueSubjectValue, issueDetailValue} = this.state;
    if (issueSubjectValue === '')
      this.setState({issueSubjectError: 'Message is required'});
    if (issueDetailValue === '')
      this.setState({issueDetailError: 'Subject is required'});

    if (issueSubjectValue.length > 0 && issueDetailValue.length > 0) {
      this.submitIssueHandling({
        issueSubjectValue: this.state.issueSubjectValue,
        issueDetailValue: this.state.issueDetailValue,
        shopData: this.state.shopData
      });
      // reset form
      this.setState({issueSubjectValue: '', issueDetailValue: ''});
    }
  };

  closeThankSubmitIssue = () => {
    this.setState({thanksIssueModal: false});
  };

  closeSubmitModal = () => {
    this.setState({submitIssueModal: false});
  };

  submitIssueHandling = (payload) => {
    const shopName = payload.shopData.name;
    const email = payload.shopData.email;
    const url = 'https://website-service-dot-autoketing-production-api-v1.appspot.com/create-ticket';
    let bodyFormData = new FormData();
    bodyFormData.set('name', shopName);
    bodyFormData.set('email', email);
    bodyFormData.set('subject', payload.issueSubjectValue);
    bodyFormData.set('message', payload.issueDetailValue);

    const appName = this.props.appName;
    switch (appName) {
      case 'fb-chat':
        bodyFormData.set('group_id', '42000096826');
        break;
      case 'sales-pop':
        bodyFormData.set('group_id', '42000097091');
        break;
      default:
        break;
    }

    const e = this;
    axios({
      method: 'POST',
      url: url,
      data: bodyFormData,
      config: {headers: {'Content-Type': 'multipart/form-data'}}
    })
      .then(response => {
        if (response.status === 200) {
          const data = response.data;
          if (data.success) {
            // Show modal success
            e.closeSubmitIssueModal();
            e.setState({thanksIssueModal: true});
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  successFeedBack = () => {

  };

  render() {
    return (
      <div>
        <Modal
          open={this.state.instructionVideoModal}
          onClose={this.closeInstructionVideo}
          title="Instruction Video"
          primaryAction={{
            content: 'OK',
            onAction: this.closeInstructionVideo
          }}>
          <Modal.Section>
            <iframe
              title="Instruction Video"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/xhta4n68p_g?rel=0&autoplay=1"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </Modal.Section>
        </Modal>
        <SubmitIssue appName={this.props.appName} closeSubmitModal={this.closeSubmitModal} successFeedBack={this.successFeedBack}
                     openModal={this.state.submitIssueModal}/>
      </div>
    )
  }
}

export default InitTopMenuBar
